export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmYUtfCRc4AMP6lbBP.d4ee1a2d.woff2";